import { Button } from '@bambi/component-library/src/components/Button/Button';
import { useCallback } from 'react';

import { adminActions } from '../admin.slice';
import { useAppDispatch } from 'src/app/store/hooks';

export function ClearviewSettingsRouteActions() {
  const dispatch = useAppDispatch();

  const handleAdd = useCallback(() => {
    dispatch(adminActions.setShowClearviewTransportPayerModal(true));
  }, [dispatch]);

  return (
    <div className="flex flex-row gap-2">
      <Button onClick={handleAdd} variant="primary">
        Add Clearview Transport Payer
      </Button>
    </div>
  );
}
